import S from 'common/service/sanctuary';
import { createSelector } from 'reselect';
import {
  resource,
} from '../../selectors';

export const getScope = ({ customer: { logo } }) => logo;

const {
  isLoading,
  getResourceContext,
  getResourceMaybe,
} = resource.factory(getScope);

const getLogo = createSelector(
  getResourceMaybe,
  logoMaybe => S.chain(logo => S.toMaybe(logo), logoMaybe),
);

export {
  isLoading,
  getResourceContext as getLogoContext,
  getResourceMaybe as getLogoMaybe,
  getLogo,
};
